import z from 'zod';
import { zodStringToDateTime } from '../utils';

export const LabSemWithIdZod = z.object({
  id: z.number(),
  year: z.number().positive(), // 入學年
  gradeID: z.number().positive(), // 檢查年級
  no: z.number().nullish(), // 檢查班級
  labKind: z.number(), // 檢查種類
  checkDate: zodStringToDateTime(), // 初查日期
  checkDate2: zodStringToDateTime(), // 複查日期
  schoolId: z.string().nullish(), // 複查日期
});

export const LabSemZod = z.object({
  id: z.number().nullish(),
  year: z.number().positive(), // 入學年
  gradeID: z.number().positive(), // 檢查年級
  no: z.number().nullish(), // 檢查班級
  labKind: z.number(), // 檢查種類
  checkDate: zodStringToDateTime(), // 初查日期
  checkDate2: zodStringToDateTime(), // 複查日期
  isSynced: z.boolean(),
  syncDate: zodStringToDateTime(), // 同步至學生健康資料日期
  schoolId: z.string().nullish(), // 複查日期
});

export const LabSemWithNullZod = z.object({
  id: z.number(),
  year: z.number().positive(), // 入學年
  gradeID: z.number().positive(), // 檢查年級
  no: z.number().positive(), // 檢查班級
  labKind: z.number(), // 檢查種類
  checkDate: zodStringToDateTime(), // 初查日期
  checkDate2: zodStringToDateTime(), // 複查日期
  schoolId: z.string().nullish(), // 複查日期
}).nullish();

export const LabSemCheckDateZod =  zodStringToDateTime(); // 複查日期

export type LabSem = z.infer<typeof LabSemZod>;
export type LabSemWithId = z.infer<typeof LabSemWithIdZod>;
export type LabSemWithNull = z.infer<typeof LabSemWithNullZod>;
export type LabSemCheckDate = z.infer<typeof LabSemCheckDateZod>;
